import { FC, ReactElement } from 'react';
import S from './IntegrationConfigurationModal.module.scss';

type Props = {
  configuration: ReactElement;
};

export const IntegrationConfigurationModal: FC<Props> = ({ configuration }) => {
  return <div className={S.integrationConfigurationModal}>{configuration}</div>;
};
